export default __webpack_public_path__ + "static/media/Apple iPad Air 2.9fc3f8e9.png";